import css from "./Pictures.module.css";
import Svg from "../../Svg/Svg";
import SvgOptions from "../../Svg/SvgOptions";
import Utils from "../../../Services/Utills";
import ScrollContainer from "react-indiana-drag-scroll";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { UploadFile } from "../../../Services/Server";
import Picture from "./Picture";

const Pictures = ({ onChange, load, onDelete, allowedTypes = ["image"] }) => {
	const id = "File-" + (Date.now() + Math.random() * 1000000);
	const [Uploads, setUploads] = useState([]);

	useEffect(() => {
		if (load?.length) setUploads(load);
	}, [load]);

	// Allowed file extensions
	const extMap = {
		image: ["png", "gif", "jpg", "jpeg", "jfif", "pjpeg", "pjp"],
		document: ["pdf", "doc", "docx"],
	};

	const isValidFile = (filename) => {
		if (!filename) return false;
		const ext = filename.split(".").pop()?.toLowerCase();

		for (const type of allowedTypes) {
			if (extMap[type]?.includes(ext)) return true;
		}
		return false;
	};

	const onUpload = (e) => {
		const files = Array.from(e.target.files);
		if (!files.length) return;

		// Documents → only one allowed
		if (allowedTypes.includes("document") && Uploads.length >= 1) {
			toast.error("Only one file allowed for this upload.");
			return;
		}

		files.forEach((file) => {
			if (!isValidFile(file.name)) {
				toast.error(`Invalid file type: ${file.name}`);
				return;
			}

			const upload = {
				value: null,
				uploadType: file.type,
				uploadId: null,
			};

			UploadFile(file, file.name)
				.then((resp) => {
					upload.uploadId = resp.id;
				})
				.catch(() => {
					toast.error("Error uploading file");
				});

			// Image preview
			if (file.type.startsWith("image/")) {
				Utils.getBase64File(file, (result) => {
					upload.value = result;
					setUploads((prev) => [...prev, upload]); // append images
				});
			} else {
				// Document (PDF/DOC)
				upload.value = file.name;
				setUploads([upload]); // replace for documents
			}
		});

		// Reset input so same file can be reselected
		e.target.value = "";
	};

	const handleDelete = (item) => {
		setUploads((prev) => prev.filter((u) => u !== item));
		onDelete && onDelete(item);
	};

	useEffect(() => {
		onChange && onChange(Uploads);
	}, [Uploads]);

	const inputAccept =
		allowedTypes.includes("image") && !allowedTypes.includes("document")
			? "image/*"
			: allowedTypes.includes("document") && !allowedTypes.includes("image")
			? ".pdf,.doc,.docx"
			: "image/*,.pdf,.doc,.docx";

	return (
		<div className={css.Wrapper}>
			<input
				id={id}
				onChange={onUpload}
				type="file"
				className={css.FileInput}
				accept={inputAccept}
				multiple={allowedTypes.includes("image")} // multi-image support
			/>

			<div className={css.Cont}>
				<div className={css.Label}>
					<label htmlFor={id}>
						<center>
							<Svg className={css.Photo}>{SvgOptions.AddPhoto}</Svg>
							{allowedTypes.includes("document")
								? " Upload File"
								: " Upload Photo"}
						</center>
					</label>
				</div>

				<div className={css.UploadedCont}>
					{Uploads.length ? (
						<ScrollContainer>
							<div className={css.Uploaded}>
								{Uploads.map((src, index) => (
									<div key={index} className={css.Image}>
										<Picture>{src}</Picture>

										<div className={css.Close}>
											<Svg
												onClick={() => handleDelete(src)}
												className={css.CloseIcon}
											>
												{SvgOptions.Close}
											</Svg>
										</div>
									</div>
								))}
							</div>
						</ScrollContainer>
					) : (
						<div className={css.NoUpload}>No file uploaded</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default Pictures;
